<script>
import Vue from 'vue'
import metaInfo from '@/modules/mixins/metaInfo'
import canteenAddresses from '@/modules/mixins/canteenAddresses'
import RestaurantCard from '@/components/organism/restaurants/RestaurantCard'
import Badge from '@/components/molecules/Badge'
import { mapGetters } from 'vuex'
import { Restaurant } from '@/api'
import store from '@/modules/store'
import { BTabs, BTab } from 'bootstrap-vue/esm/components/tabs'
import { CloudCanteen } from '@/api/models/cloudCanteen'

export default {
    name: 'Select',
    components: { Badge, RestaurantCard, BTabs, BTab },
    mixins: [canteenAddresses, metaInfo],
    data() {
        return {
            canteenLocation: null,
            activeOrderDates: [],
        }
    },
    computed: {
        ...mapGetters({
            smDevice: 'smDevice',
            locale: 'locale',
            activeCanteen: 'active/canteen',
        }),
        pageTitle() {
            return this.$t('labels.restaurants')
        },
        canteensByDate() {
            return this.groupBy(this.canteenLocation?.canteens, 'cutoff_date')
        },
    },
    async mounted() {
        const api = new CloudCanteen()
        this.activeOrderDates = await api.fetch(`active-orders/${this.$route.params.location}`)
    },
    methods: {
        setCanteenLocation(type, location) {
            this.type = type
            if (this.type === this.cloud)
                this.canteenLocation = this.cloudCanteenAddresses.find(
                    (address) => address.id == location
                )
            if (this.type === this.residential)
                this.canteenLocation = this.residentialCanteenAddresses.find(
                    (address) => address.id == location
                )
        },
        async select(canteen, restaurant) {
            restaurant = new Restaurant(restaurant)
            if (
                canteen.id !== this.activeCanteen?.id ||
                this.$cart.restaurant !== restaurant.link
            ) {
                await this.$store.dispatch('active/setCanteen', canteen)
                this.$cart.resetCart()
                this.$cart.restaurant = restaurant.link
            }
            await this.$user.getExpenseRules()
            await this.$restaurant.fetchRestaurant(restaurant.slug, {
                [`${this.$route.params.type}canteen`]: canteen.id,
            })
            await this.$router.push({
                name: 'restaurant-canteen',
                params: {
                    slug: restaurant.slug,
                    type: this.$route.params.type,
                    id: canteen.id,
                },
            })
        },
        refreshCanteenList() {
            setInterval(async () => {
                await this.$user.getMe()
                this.setCanteenLocation(this.$route.params.type, this.$route.params.location)
            }, this.refreshInterval)
        },
        async refreshResidentialCanteenList() {
            setInterval(async () => {
                await store.dispatch('canteen/getResidentialList')
                this.setCanteenLocation(this.$route.params.type, this.$route.params.location)
            }, this.refreshInterval)
        },
    },
    async beforeRouteEnter(to, from, next) {
        await store.dispatch('canteen/getResidentialList')
        if (!Vue.prototype.$addresses.total && Vue.prototype.$user.isLoggedIn)
            await Vue.prototype.$addresses.fetch()
        next((vm) => {
            vm.setCanteenLocation(to.params.type, to.params.location)
            if (!vm.canteenLocation) next({ name: 'not-found' })
            if (to.params.type === vm.cloud) vm.refreshCanteenList()
            else if (to.params.type === vm.residential) vm.refreshResidentialCanteenList()
        })
        next()
    },
}
</script>

<template lang="pug">
.canteen-select
    .mb-8(v-if="activeOrderDates.length")
        h2 {{ $t('canteen.already_placed') }}
        div(v-for="activeOrderDate in activeOrderDates")
            h3.font-weight-normal.text-73 {{ activeOrderDate | toDayMonth(4) }}
    b-tabs(:nav-class="{'stretch bg-white': smDevice}")
        b-tab(
            v-for="(canteens, date) in canteensByDate"
            :id="`tab-${date}`"
            :key="`content-${date}`")
            template(#title)
                h2.mb-0(:key="`${date}-${locale}`") {{date.replace(/_/g, '-') | toDayMonth(3)}}
            div(v-for="canteen in canteens" :key="`canteen-${date}-${canteen.id}`")
                .d-flex.flex-column.align-items-start.mb-6.mt-8
                    h2.mb-3.text-break  {{canteen.name}}
                    badge.mt-3.text-nowrap(type="secondary" pill) {{$t('labels.delivery')}}: {{canteen.delivery_time | toDeliveryTime}}
                h3.font-weight-normal.text-73 {{$t('canteen.place_order_by')}} {{canteen.cutoff_time | toDayMonthTime}}
                .row
                    restaurant-card.mb-9(
                        v-for="restaurant in canteen.restaurants"
                        @click="select(canteen, restaurant)"
                        :model="restaurant"
                        :key="`canteenRestaurant-${date}-${canteen.id}-${restaurant.id}`"
                        :canteen="restaurant.cutoffTimeOverride || canteen.cutoff_time")


</template>
